"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ScriptsAddWp;
var jsx_runtime_1 = require("react/jsx-runtime");
var FlatsomeInitializer_1 = require("../client/initializers/FlatsomeInitializer");
var forminatorProps_1 = require("../../lib/head/js/client/forminatorProps");
var react_1 = require("react");
var models_1 = require("../../lib/models");
function ScriptsAddWp() {
    (0, react_1.useEffect)(function () {
        var _a;
        (0, models_1.modelScripts)();
        try {
            var schema = (_a = document.querySelector(".yoast-schema-graph")) !== null && _a !== void 0 ? _a : document.querySelector('[type="application/ld+json"]');
            if (!(schema instanceof HTMLElement))
                throw new Error("Failed to fetch yoast schema element");
            if (!/image/.test(schema.innerHTML)) {
                try {
                    var schemaData = JSON.parse(schema.innerText);
                    schemaData.image = {
                        "@type": "ImageObject",
                        url: "https://blog.organolab.com.br/images/orglab_logo_og_630.png",
                        width: 630,
                        height: 630,
                    };
                    schema.textContent = JSON.stringify(schemaData, null, 2);
                }
                catch (e) {
                    console.error("Failed to parse schema JSON: ".concat(e.message));
                }
            }
        }
        catch (e) {
            console.error("Error executing useEffect for Scripts:".concat(e.message));
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FlatsomeInitializer_1.default, {}), (0, jsx_runtime_1.jsx)("script", { type: "text/javascript", defer: true, id: "forminator-front-scripts-js-extra", crossOrigin: "anonymous", dangerouslySetInnerHTML: {
                    __html: "const ForminatorFront = ".concat(JSON.stringify(forminatorProps_1.default)),
                } }), (0, jsx_runtime_1.jsx)("script", { type: "text/javascript", defer: true, src: "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js", integrity: "sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz", crossOrigin: "anonymous", id: "boostrap-script" })] }));
}
